import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions';
import { auth } from '../../../services';

export const GET_COMMITTEES = 'GET_COMMITTEES';
export const GET_PARENT_COMMITTEES = 'GET_PARENT_COMMITTEES';
export const GET_COMMITTEE_TYPES = 'GET_COMMITTEE_TYPES';
export const ADD_COMMITTEE = 'ADD_COMMITTEE';
export const DELETE_COMMITTEE = 'DELETE_COMMITTEE';
export const UPDATE_COMMITTEE = 'UPDATE_COMMITTEE';
export const GET_POSITIONS_BYGROUP = 'GET_POSITIONS_BYGROUP';
export const ADD_COMMITTEE_DOCUMENTS = 'ADD_COMMITTEE_DOCUMENTS';
export const GET_COMMITTEE_DOCUMENTS = 'GET_COMMITTEE_DOCUMENTS';
export const DELETE_COMMITTEE_DOCUMENT = 'DELETE_COMMITTEE_DOCUMENT';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchCommittees() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageCommittee/GetCommittees`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_COMMITTEES,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function fetchParentCommittees() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageCommittee/GetParentCommittee`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_PARENT_COMMITTEES,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}


export function getCommitteeTypes(role) {
	return function(dispatch) {
		axios
			.get(`${ROOT_API_URL}/ManageCommittee/GetCommitteeTypes`, { headers: auth.authHeader() })
			.then((response) =>
				dispatch({
					type: GET_COMMITTEE_TYPES,
					payload: response.data
				})
			)
			.catch((response) => {
				console.log(response);
			});
	};
}

export function addCommittee(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageCommittee/CreateCommittee`, model, { headers: auth.authHeader() })
			.then(function(response){	
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: ADD_COMMITTEE,
						payload: response.data.committees,
					});
					var success = response && response.data ? response.data.message : "Committee Created Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Committee Already Exists"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function deleteCommittee(user) {

	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageCommittee/DeleteCommittee`, user, { headers: auth.authHeader() })
			.then((response) =>
			{
			if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: DELETE_COMMITTEE,
					payload: response.data.committees
					});	
					var success = response && response.data ? response.data.message : "Committee Deleted Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function updateCommittee(user) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageCommittee/UpdateCommittee`, user, { headers: auth.authHeader() })
			.then((response) => {
				console.log("update response", response)
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: UPDATE_COMMITTEE,
						payload: response.data.committees
					});	
					var success = response && response.data ? response.data.message : "Committee Updated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}
export function saveCommitteeDocument(model) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageCommittee/SaveCommitteeDocument`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, model, options).then(function(response) {
				if (response && response.data) 
				{
					dispatch({
						type: ADD_COMMITTEE_DOCUMENTS,
						payload: response.data.committeeDocuments
					});	
					var success =  "Notes Created Sucessfully" ; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err =  "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function dispatchLoader() {
	return function (dispatch) {
		dispatch(loader(true));
	};
}

export function dispatchError() {
	return function (dispatch) {
		var err = 'Network Connection Error';
		dispatch(loader(false));
		dispatch(toastr(true, err, errorColor));
	};
}

export function checkResponse(response) {
	return function (dispatch) {
		if (response && response.data) {
			dispatch({
				type: ADD_COMMITTEE_DOCUMENTS,
				payload: response.data.committeeDocuments
			});
			var success = "Document Uploaded Sucessfully";
			dispatch(toastr(true, success, successColor));
		}
		else {
			var err = "Error Occured";
			dispatch(toastr(true, err, warningColor));
		}
		dispatch(loader(false));
	};
}

export function getCommitteeDocuments(committeeId) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageCommittee/GetCommitteeDocuments?committeeId=${committeeId}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_COMMITTEE_DOCUMENTS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function GetCommitteeDocumentsByCommitteeMemberId(committeeMemberId) {
	return function (dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageCommittee/GetCommitteeDocumentsByCommitteeMemberId?committeeMemberId=${committeeMemberId}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_COMMITTEE_DOCUMENTS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error";
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function deleteCommitteeDocument(committee) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageCommittee/DeleteCommitteeDocument`, committee, { headers: auth.authHeader() })
			.then((response) =>
			{
			if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: DELETE_COMMITTEE_DOCUMENT,
					payload: response.data.committeeDocuments
					});	
					var success = response && response.data ? response.data.message : "Committee Document Deleted Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}